/*
==========================================
Rootslane Quick Add
Version 2
==========================================
*/

(() => {

    "use strict";

    const RootslaneQuickAdd = {

        selectors: {

            productForms: "product-form",

            submitButton: ".quick-add__submit:not(.rl-added)",

            variantInput: "input[name='id']"

        },

    async init() {

    await this.loadCart();

    this.bindProductForms();

    this.bindEvents();

    this.restoreCart();

    this.syncProductPageQuantity();

    this.bindProductPageQuantityReplace();

},

        bindProductForms() {

            document
                .querySelectorAll(this.selectors.productForms)
                .forEach((form) => {

                    this.prepareProductForm(form);

                });

        },

     prepareProductForm(productForm) {

    const button =
        productForm.querySelector(this.selectors.submitButton);

    if (!button) return;

    button.dataset.rlReady = "true";

    /*
     * Prevent duplicate submit listeners.
     */
    if (productForm.dataset.rlAnimationReady === "true") {
        return;
    }

    productForm.dataset.rlAnimationReady = "true";

    /*
     * Show the same waving dots animation
     * used by the + / - quantity selector
     * while adding the first item.
     */
    productForm.addEventListener("submit", () => {

        if (button.classList.contains("loading")) {
            return;
        }

        let dots = button.querySelector(".rl-dots");

        if (!dots) {

            dots = document.createElement("span");

            dots.className = "rl-dots";

            dots.innerHTML = `
                <span></span>
                <span></span>
                <span></span>
            `;

            button.appendChild(dots);
        }

        button.classList.add("loading");

        button.setAttribute(
            "aria-busy",
            "true"
        );

    });

},

                async loadCart() {

    try {

        const response =
            await fetch("/cart.js");
if (!response.ok) {

    throw new Error(
        "Unable to load cart."
    );

}
        const cart =
            await response.json();

        this.updateCartCache(cart);
        this.notifyCartUpdated(cart);

        console.log(
            "Rootslane Cart Loaded",
            this.cart
        );

    }

    catch (error) {

        console.error(
            "Rootslane Cart Error",
            error
        );

    }

},
                updateCartCache(cart) {

            this.cart = {};

            cart.items.forEach((item) => {

                this.cart[
                    String(item.variant_id)
                ] = {

                    quantity: item.quantity,

                    key: item.key

                };

            });

        },

                notifyCartUpdated(cart) {

            document.dispatchEvent(

                new CustomEvent(

                    "rootslane:cart-updated",

                    {

                        detail: {

                            cart

                        }

                    }

                )

            );

        },

        dispatchCartErrorEvent(
    message,
    code = "INVALID"
) {

    const { CartErrorEvent } =
        window.StandardEvents || {};

    if (!CartErrorEvent) return;

    document.dispatchEvent(

        new CartErrorEvent({

            error: message,

            code

        })

    );

},

  async refreshThemeSections() {

    try {

        const response = await fetch(
            `${window.location.pathname}?section_id=header`
        );

        if (!response.ok) return;

        const html = await response.text();

        const doc = new DOMParser().parseFromString(
            html,
            "text/html"
        );

        // ------------------------
        // Update Cart Icon
        // ------------------------

        const newBubble =
            doc.querySelector("#cart-icon-bubble");

        const currentBubble =
            document.querySelector("#cart-icon-bubble");

        if (newBubble && currentBubble) {

            currentBubble.replaceWith(newBubble);

        }

        // ------------------------
        // Update Cart Drawer
        // ------------------------

        const newDrawer =
            doc.querySelector("#CartDrawer");

        const currentDrawer =
            document.querySelector("#CartDrawer");

        if (newDrawer && currentDrawer) {

            currentDrawer.innerHTML =
                newDrawer.innerHTML;

        }

    }

    catch (error) {

        console.error(
            "Unable to refresh theme sections",
            error
        );

    }

},
                refreshProductForm(productForm) {

            const variantInput =
                productForm.querySelector(
                    this.selectors.variantInput
                );

            if (!variantInput) return;
            const isAvailable =
    variantInput.dataset.available === "true";

if (!isAvailable) {

    const existing =
        productForm.querySelector(".rl-qty-selector");

    if (existing) {
        existing.remove();
    }

    return;
}

            const variantId =
                String(variantInput.value);

            const cartItem =
                this.cart[variantId];

            const button =
                productForm.querySelector(
                    ".quick-add__submit"
                );

            if (!button) return;

            if (!cartItem) {

                const existing =
                    productForm.querySelector(
                        ".rl-qty-selector"
                    );

                if (existing) {

                    existing.remove();

                }

                button.style.display = "";

                return;

            }

            this.renderQuantitySelector(

                productForm,

                cartItem.quantity,

                variantId

            );

        },

        refreshAllProductForms(variantId) {

            document
                .querySelectorAll(
                    this.selectors.productForms
                )
                .forEach((productForm) => {

                    const variantInput =
                        productForm.querySelector(
                            this.selectors.variantInput
                        );

                    if (!variantInput) return;

                    if (
                        String(variantInput.value) !==
                        String(variantId)
                    ) {
                        return;
                    }

                    this.refreshProductForm(
                        productForm
                    );

                });

        },

                restoreCart() {

            document
                .querySelectorAll(
                    this.selectors.productForms
                )
                .forEach((productForm) => {

                    this.refreshProductForm(
                        productForm
                    );

                });

        },

        syncProductPageQuantity() {

    /*
    Only run on a product page
    */

    const quantityInput =
        document.querySelector(
            ".product-form__quantity .quantity__input"
        );

    if (!quantityInput) {
        return;
    }


    /*
    Get the currently selected
    product variant directly.
    */

    const variantInput =
        document.querySelector(
            "product-form input[name='id']"
        );

    if (!variantInput) {
        console.log(
            "Rootslane: Product variant input not found"
        );

        return;
    }


    const variantId =
        String(
            variantInput.value
        );


    /*
    Look for this variant in the
    cart that we already loaded.
    */

    const cartItem =
        this.cart[variantId];


    console.log(
        "Rootslane Product Page Quantity Check",
        {
            variantId: variantId,
            cartItem: cartItem
        }
    );


    /*
    Product is NOT in cart.
    Leave Shopify's default quantity = 1.
    */

    if (!cartItem) {

        quantityInput.value = "1";

        return;
    }


    /*
    Product IS already in cart.
    */

    const cartQuantity =
        Number(
            cartItem.quantity
        ) || 1;


    quantityInput.value =
        String(
            cartQuantity
        );


    /*
    Update Shopify's data attribute too.
    */

    quantityInput.dataset.cartQuantity =
        String(
            cartQuantity
        );


    /*
    Update "(X in cart)"
    */

    const cartQuantityText =
        document.querySelector(
            ".quantity-cart"
        );

    if (cartQuantityText) {

        cartQuantityText.textContent =
            String(
                cartQuantity
            );

    }


    console.log(
        "Rootslane Product Quantity Set",
        {
            variantId: variantId,
            quantity: cartQuantity
        }
    );

},     

bindProductPageQuantityReplace() {

    const quantityInput =
        document.querySelector(
            ".product-form__quantity .quantity__input"
        );

    if (!quantityInput) {
        return;
    }


    /*
    Find the actual Shopify form.

    IMPORTANT:
    Shopify's product-form.js attaches
    its submit handler directly to this
    inner <form>.
    */

    const form =
        quantityInput.form ||
        document.querySelector(
            "form[id^='product-form-']"
        );

    if (!form) {
        console.log(
            "Rootslane: Product form not found"
        );

        return;
    }


    /*
    Prevent duplicate listener.
    */

    if (
        form.dataset.rlQuantityReplaceReady ===
        "true"
    ) {
        return;
    }

    form.dataset.rlQuantityReplaceReady =
        "true";


    /*
    Listen directly on the FORM.

    Capture = true means our handler
    runs BEFORE Shopify's normal
    product-form submit handler.
    */

    form.addEventListener(
        "submit",
        async (event) => {

            const variantInput =
                form.querySelector(
                    "input[name='id']"
                );

            if (!variantInput) {
                return;
            }


            const variantId =
                String(
                    variantInput.value
                );


            /*
            Check Rootslane's current
            cart cache.
            */

            const cartItem =
                this.cart[variantId];


            /*
            Product isn't already in cart.

            Leave normal Shopify Add to Cart
            completely untouched.
            */

            if (!cartItem) {
                return;
            }


            /*
            PRODUCT IS ALREADY IN CART.

            Stop Shopify's normal
            "add quantity" operation.
            */

            event.preventDefault();
            event.stopImmediatePropagation();


            const desiredQuantity =
                Math.max(
                    1,
                    parseInt(
                        quantityInput.value,
                        10
                    ) || 1
                );


            console.log(
                "Rootslane Product Quantity Replace",
                {
                    variantId:
                        variantId,

                    currentCartQuantity:
                        cartItem.quantity,

                    desiredQuantity:
                        desiredQuantity
                }
            );


            /*
            Prevent double click.
            */

            const submitButton =
                form.querySelector(
                    "[type='submit']"
                );

            if (
                submitButton &&
                submitButton.dataset.rlReplacing ===
                "true"
            ) {
                return;
            }


            if (submitButton) {

                submitButton.dataset.rlReplacing =
                    "true";

                submitButton.setAttribute(
                    "aria-disabled",
                    "true"
                );

                submitButton.classList.add(
                    "loading"
                );

            }


            try {

                /*
                IMPORTANT:

                cart/change.js SETS the quantity.

                It does NOT ADD to the existing
                quantity.
                */

                const response =
                    await fetch(
                        "/cart/change.js",
                        {
                            method: "POST",

                            headers: {
                                "Content-Type":
                                    "application/json"
                            },

                            body:
                                JSON.stringify({
                                    id:
                                        cartItem.key,

                                    quantity:
                                        desiredQuantity
                                })
                        }
                    );


                if (!response.ok) {

                    const error =
                        await response.json();

                    throw new Error(
                        error.description ||
                        error.message ||
                        "Unable to update cart."
                    );

                }


                const updatedCart =
                    await response.json();


                /*
                Update Rootslane cache.
                */

                this.updateCartCache(
                    updatedCart
                );

                this.notifyCartUpdated(
                    updatedCart
                );


                /*
                Keep product page quantity
                synchronized.
                */

                quantityInput.value =
                    String(
                        desiredQuantity
                    );

                quantityInput.dataset.cartQuantity =
                    String(
                        desiredQuantity
                    );


                /*
                Update "(X in cart)".
                */

                const cartQuantityText =
                    document.querySelector(
                        ".quantity-cart"
                    );

                if (cartQuantityText) {

                    cartQuantityText.textContent =
                        String(
                            desiredQuantity
                        );

                }


                /*
                Refresh header/cart icon.
                */

                await this.refreshThemeSections();


                console.log(
                    "Rootslane Product Quantity Updated",
                    {
                        variantId:
                            variantId,

                        quantity:
                            desiredQuantity
                    }
                );

            }
            catch (error) {

                console.error(
                    "Rootslane Product Quantity Error",
                    error
                );

                if (
                    window.RootslaneToast
                ) {

                    window.RootslaneToast.show(
                        error.message
                    );

                }

            }
            finally {

                if (submitButton) {

                    submitButton.classList.remove(
                        "loading"
                    );

                    submitButton.removeAttribute(
                        "aria-disabled"
                    );

                    delete submitButton.dataset
                        .rlReplacing;

                }

            }

        },
        true
    );


    console.log(
        "Rootslane Product Quantity Replace Ready"
    );

},

                renderQuantitySelector(

            productForm,

            quantity,

            variantId

        ) {

            const button =
                productForm.querySelector(
                    ".quick-add__submit"
                );

            if (!button) return;

            button.style.display = "none";

            const existing =
                productForm.querySelector(
                    ".rl-qty-selector"
                );

            if (existing) {

                existing.remove();

            }

            const qty =
                document.createElement("div");

            qty.className =
                "rl-qty-selector";

            qty.dataset.variantId =
                variantId;

            qty.innerHTML = `

                <button
                    type="button"
                    class="rl-minus"
                >
                    −
                </button>

               <span class="rl-count">

    <span class="rl-count-value">

        ${quantity}

    </span>

</span>
                <button
                    type="button"
                    class="rl-plus"
                >
                    +
                </button>

            `;

            button.insertAdjacentElement(

                "afterend",

                qty

            );

            const count =
                qty.querySelector(
                    ".rl-count"
                );

            qty.addEventListener(

                "click",

                async (e) => {

                    const plus =
                        e.target.closest(
                            ".rl-plus"
                        );

                    const minus =
                        e.target.closest(
                            ".rl-minus"
                        );

                    if (plus) {

                        await this.changeQuantity(

                            qty,

                            count,

                            button,

                            1

                        );

                    }

                    if (minus) {

                        await this.changeQuantity(

                            qty,

                            count,

                            button,

                            -1

                        );

                    }

                }

            );

        },

        bindEvents() {

            document.addEventListener(

                "rootslane:item-added",

               async (event) => {

    await this.onItemAdded(event);

}

            );

             document.addEventListener(
        "rootslane:refresh-cart-icon",
        async () => {
            await this.refreshThemeSections();
        }
    );

        },

        async onItemAdded(event) {

    const productForm =
        event.detail.form;

    if (!productForm) {
        return;
    }

    const button =
        productForm.querySelector(
            ".quick-add__submit"
        );

    if (!button) {
        return;
    }

    /*
     * 0 → 1 has NO animation.
     * Immediately remove loading state.
     */

    button.classList.remove("loading");

    button.removeAttribute("aria-busy");


    /*
     * Get the response that Shopify
     * already returned from /cart/add.
     */

    const item =
        event.detail.response;


    if (
        item &&
        item.variant_id &&
        item.key
    ) {

        const variantId =
            String(item.variant_id);


        /*
         * Update Rootslane's local cart
         * using the response we already have.
         */

        this.cart[variantId] = {

            quantity:
                Number(item.quantity) || 1,

            key:
                item.key

        };


        /*
         * Immediately convert
         * Add to Cart → − 1 +
         */

        this.refreshProductForm(
            productForm
        );


        /*
         * Synchronize the complete cart
         * in the background.
         *
         * DO NOT await.
         */

       // this.loadCart();


    } else {

        /*
         * Safety fallback.
         */

        const variantId =
            String(
                event.detail.variantId
            );

        await this.loadCart();

        this.refreshAllProductForms(
            variantId
        );

    }

},

async changeQuantity(
    qty,
    count,
    button,
    delta
) {

    const plusButton =
        qty.querySelector(".rl-plus");

    const minusButton =
        qty.querySelector(".rl-minus");

        const countValue =
    qty.querySelector(
        ".rl-count-value"
    );

    const originalQuantity =
    countValue.textContent;

    if (qty.dataset.loading === "true") {
        return;
    }

    qty.dataset.loading = "true";

    plusButton.disabled = true;
    minusButton.disabled = true;
countValue.innerHTML = `
    <span class="rl-dots">
        <span></span>
        <span></span>
        <span></span>
    </span>
`;

qty.classList.add(
    "rl-loading"
);
    try {

        const variantId =
            String(qty.dataset.variantId);

        let cartItem =
            this.cart[variantId];
            
        // Safety check if cache is missing
        if (!cartItem) {

            await this.loadCart();

            cartItem =
                this.cart[variantId];

        }

        if (!cartItem) {

            throw new Error(
                "Item not found in cart."
            );

        }

        const newQuantity =
            cartItem.quantity + delta;
            // Respect Shopify inventory


       const response =
    await fetch(
        "/cart/change.js",
        {
            method: "POST",

            headers: {
                "Content-Type":
                    "application/json"
            },

            body: JSON.stringify({

                id: cartItem.key,

                quantity:
                    Math.max(
                        0,
                        newQuantity
                    )

            })
        }
    );

 if (!response.ok) {

    const error =
        await response.json();

    this.dispatchCartErrorEvent(

    error.description ||
    error.message ||
    "INVALID"

);

throw new Error(

    error.description ||
    error.message ||
    "Unable to update quantity."

);

}

const updatedCart =
    await response.json();

this.updateCartCache(updatedCart);

this.notifyCartUpdated(updatedCart);

await this.refreshThemeSections();

this.refreshAllProductForms(
    variantId
);

if (newQuantity <= 0) {

    return;

}
}

catch (error) {

    console.error(
        "Rootslane Quick Add:",
        error
    );

    if (
        window.RootslaneToast
    ) {

        window.RootslaneToast.show(
            error.message
        );

    }

}

   finally {

    qty.dataset.loading = "false";

    qty.classList.remove(
        "rl-loading"
    );

    const latestItem =
        this.cart[
            String(
                qty.dataset.variantId
            )
        ];

    if (latestItem) {

        countValue.textContent =
            latestItem.quantity;

    }

    plusButton.disabled = false;
    minusButton.disabled = false;

}

},

       };

    document.addEventListener(

        "rootslane:cart-updated",

        (event) => {

            console.log(

                "Rootslane Cart Updated",

                event.detail.cart

            );

        }

    );

    document.addEventListener(

        "DOMContentLoaded",

        async () => {

            await RootslaneQuickAdd.init();

        }

    );

})();